export default __webpack_public_path__ + "static/media/e-logo.417c8c74.png";